<template>
  <div class="layout-padding">


    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      title="1:1 문의 조회"
      desc="현재 신규로 들어온 1:1 문의 게시물들의 현황을 조회할 수 있습니다.">

      <!-- 문의 카테고리 -->
      <div slot="one_category">
        <span class="select">
          <select @change="selectCategory">
            <option value="" disabled selected>카테고리</option>
            <option v-for="(cat, idx) in form_cat_arr"
                    :key="'cat'+idx"
                    :value="cat.value">{{ cat.label }}</option>
          </select>
        </span>
      </div>
    </admin-filter>

    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 nextPageName="nopage"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength">

      <div slot="estimate_content" slot-scope="props" style="width: 120px; margin: auto;">
        <div @click.stop.prevent="clickEst(props.item)">
          <i class="material-icons">library_books</i>
        </div>
      </div>


      <div slot="status" slot-scope="props">
        <div v-if="props.item.status===0">신규요청</div>
        <div v-else-if="props.item.status===1">요청확인</div>
        <div v-else-if="props.item.status===2">진행중</div>
        <div v-else-if="props.item.status===3">완료</div>
      </div>

      <div slot="status_button" slot-scope="props">
        <button class="button btn-confirm" @click="changeStatus(props.item, 1)" v-if="props.item.status===0">신규문의확인</button>
        <button class="button btn-process" @click="changeStatus(props.item, 2)" v-if="props.item.status===1">진행중</button>
        <button class="button btn-success" @click="changeStatus(props.item, 3)" v-if="props.item.status===2">진행완료</button>
        <div v-else-if="props.item.status===3">-</div>
      </div>

      <div slot="comment_status" slot-scope="props" style="width: 120px; margin: auto;">
        <button v-if="props.item.is_answered"
                class="button is-grey cancel"
                @click.stop.prevent="clickAnswer(props.item.id)">답변 수정</button>
        <button v-if="!props.item.is_answered"
                class="button state-btn btn-make-comment"
                @click.stop.prevent="clickAnswer(props.item.id)">답변 달기</button>
        <button v-if="props.item.is_answered"
                class="button state-btn">답변 확인</button>
      </div>

    </admin-table>
  </div>
</template>

<script>
  import ListMixin from '@/mixins/ListMixin'

  import moment from 'moment';
  import BreadCrumb from '../../module/common/BreadCrumb'
  import { SweetModal } from "sweet-modal-vue";
  import LpSortDropDown from '../../module/common/LpSortDropDown'
  import LpRadio from '../../module/common/LpRadio'

  import LpInputText from "../../module/common/LpInputText";

  export default {

    mixins: [
      ListMixin
    ],

    components: {
      LpInputText,
      SweetModal,
      LpSortDropDown,
      LpRadio
    },
    created() {
      this.init();

    },
    data() {
      return {
        tableItems: [],
        qnaItem:{
          id:0,
          answer_content:''
        },
        // 카테고리
        form_cat_arr:[]
      };
    },
    watch: {
      'filtered.ordering'(){
        this.getData();
      },
      'filtered.is_new'(){
        this.getData();
      },
      'filtered.is_answered'(){
        this.getData();
      }
    },
    methods: {
      init () {
        this.initializing('launchpack_onetoone', 'inquiry/personal');

        if (this.isLaunchpack) {
          let filterData = this.cloneItem(this.filterData);
          filterData.push({
            title: '서비스 구분',
            type: 'dropdown',
            key: 'channel',
          })
          this.filterData = filterData;
        }


        this.nowTime = moment().format("YY-MM-DD");
        //this.getData();
        this.getCategory();
        //this.filtered.is_new = 'false';
        // 신규 요청 상태
        this.filtered.status = 0;
        this.filtered.is_answered = 'false';
      },
      getDataFromServer() {
        this.getData();
      },
      changeStatus(item, status) {
        this.$axios.post(this.getUrl(`inquiry/personal/${item.id}/status/change`), {
          status: status
        }).then(res=>{
          if(res.status===200) {
            item.status=status;
          }
        })
      },
      // 문의 카테고리 선택
      selectCategory(e) {
        this.filtered.category = e.target.value;
        this.getData();
      },
      // 답변 달기
      clickAnswer(id){
        this.$router.push(this.getPath('cs/inquiry/create?id='+id));
      },
      getCategory(){
        this.$axios.get('admin/inquiry/personal/category').then(res=>{
          if(res.status===200){
            this.form_cat_arr = res.data;
          }
        })
      }
    }
  };
</script>

<style lang="stylus" type="stylus" scoped>
  ////@import '~assets/css/reset';
  //@import '~assets/css/lp_main';

  .tr-whole-border th {
    padding: 12px 6px;
  }

  .many-field-tr td {
    padding: 6px;
  }

  .lp-form-type {
    color: #787878;
    display: table-cell;
    font-size: 0.8rem;
  }

  .table-cell {
    text-align: left;
    width: 100%;
  }

  .est-title
    padding-bottom 12px


  .est-content
    font-size 0.9rem

  .btn-process
  .btn-confirm
  .btn-success
    color white


  .btn-confirm
    background-color #ffc107

  .btn-process
    background-color #4dbd74

  .btn-success
    background-color #fd7014

</style>
